@import "~@govbr-ds/core/src/components/loading/loading";

:host {
  display: block;

  .loading-progress-alignment {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
}
